import CasinoTV from "../../components/CasinoTV.jsx";
import React from "react";

export default function ThreeCardJ() {
  return (
    <app-card-judgment _nghost-ng-c2077610334="">
      <div _ngcontent-ng-c2077610334="">
        <app-video-player _ngcontent-ng-c2077610334="" _nghost-ng-c595356512="">
          <div _ngcontent-ng-c595356512="" className="videoPlayer">
            <CasinoTV casinoGames="UNI_3_CARD_JUDGMENT_A" />

            <div _ngcontent-ng-c595356512="" className="video-overlay">
              <div _ngcontent-ng-c595356512="">
                <div _ngcontent-ng-c595356512="" className="round-id">
                  RID: 9400303194149
                </div>

                <div _ngcontent-ng-c595356512="" className="video-overlay aa">
                  <div _ngcontent-ng-c595356512="">
                    <div _ngcontent-ng-c595356512="">
                      <h3
                        _ngcontent-ng-c595356512=""
                        className="text-white"
                        style={{ fontSize: "9px !important" }}
                      >
                        Cards
                      </h3>
                      <div
                        _ngcontent-ng-c595356512=""
                        className="d-flex align-items-center"
                      >
                        <img
                          _ngcontent-ng-c595356512=""
                          className="card-img"
                          src="assets/cards/0.png"
                        />
                        <img
                          _ngcontent-ng-c595356512=""
                          className="card-img"
                          src="assets/cards/0.png"
                        />
                        <img
                          _ngcontent-ng-c595356512=""
                          className="card-img"
                          src="assets/cards/0.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div _ngcontent-ng-c595356512="" className="winnerOverlay">
              <div
                _ngcontent-ng-c595356512=""
                className="mini-result-new resultRemover"
              ></div>
            </div>

            <div _ngcontent-ng-c595356512="" className="timer-overlay"></div>
          </div>

          <div
            _ngcontent-ng-c595356512=""
            id="rulesModal"
            tabIndex={-1}
            aria-labelledby="exampleModalLabelaexampleModalLabela"
            aria-hidden="true"
            className="modal fade"
          >
            <div
              _ngcontent-ng-c595356512=""
              className="modal-dialog rules-wrap"
            >
              <div
                _ngcontent-ng-c595356512=""
                role="document"
                id="rulesList___BV_modal_content_"
                tabIndex={-1}
                className="modal-content rules-content"
              >
                <header
                  _ngcontent-ng-c595356512=""
                  id="rulesList___BV_modal_header_"
                  className="rules-wrap"
                >
                  <a _ngcontent-ng-c595356512="">
                    <h3
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_title_"
                      data-bs-toggle="modal"
                      data-bs-target="#rulesModal"
                      className="modal-title"
                    >
                      {" "}
                      Rules
                    </h3>
                  </a>
                  <button
                    _ngcontent-ng-c595356512=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    ×
                  </button>
                </header>
                <div
                  _ngcontent-ng-c595356512=""
                  id="rulesList___BV_modal_body_"
                  className="modal-body"
                >
                  <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                </div>
                <div _ngcontent-ng-c595356512="">
                  <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                    <li _ngcontent-ng-c595356512="">
                      <a
                        _ngcontent-ng-c595356512=""
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="btnok"
                      >
                        OK
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </app-video-player>
      </div>
      <div
        _ngcontent-ng-c2077610334=""
        id="marketScroll"
        style={{ overflowY: "auto", height: 576 }}
      >
        <div
          _ngcontent-ng-c2077610334=""
          className="threecardjbox back suspended"
        >
          <div _ngcontent-ng-c2077610334="" className="threecard-title">
            <span _ngcontent-ng-c2077610334="" className="f-16">
              Yes
            </span>
            <span
              _ngcontent-ng-c2077610334=""
              className="profitLoss-font"
            ></span>
            <div _ngcontent-ng-c2077610334="" className="casino-odds" />
          </div>
          <div _ngcontent-ng-c2077610334="" className="threecardj-cards">
            <h4 _ngcontent-ng-c2077610334="" className="text-center w-100 mb-2">
              <b _ngcontent-ng-c2077610334="" className="f-16">
                {" "}
                1.78{" "}
              </b>
            </h4>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/1.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/2.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/3.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/4.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/5.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/6.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/7.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/8.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/9.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/10.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/11.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/12.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/13.jpg"
                />
              </div>
            </div>
            <div
              _ngcontent-ng-c2077610334=""
              className="casino-min-max text-dark"
            >
              <marquee
                _ngcontent-ng-c2077610334=""
                direction="left"
                scrollamount={3}
                behavior="scroll"
              >
                Select any 3 card and you will win if you will get at least 1
                card from the 3 cards you have selected.
              </marquee>
            </div>
          </div>
        </div>

        <div
          _ngcontent-ng-c2077610334=""
          className="threecardjbox lay suspended"
        >
          <div _ngcontent-ng-c2077610334="" className="threecard-title">
            <span _ngcontent-ng-c2077610334="" className="f-16">
              No
            </span>
            <span
              _ngcontent-ng-c2077610334=""
              className="profitLoss-font"
            ></span>
            <div _ngcontent-ng-c2077610334="" className="casino-odds" />
          </div>
          <div _ngcontent-ng-c2077610334="" className="threecardj-cards">
            <h4 _ngcontent-ng-c2077610334="" className="text-center w-100 mb-2">
              <b _ngcontent-ng-c2077610334="" className="f-16">
                {" "}
                1.84{" "}
              </b>
            </h4>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/1.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/2.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/3.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/4.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/5.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/6.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/7.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/8.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/9.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/10.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/11.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/12.jpg"
                />
              </div>
            </div>
            <div _ngcontent-ng-c2077610334="" className="card-odd-box">
              <div _ngcontent-ng-c2077610334="" className="img-div">
                <img
                  _ngcontent-ng-c2077610334=""
                  data-bs-toggle=""
                  src="./../../../../../assets/3cardjudgment/13.jpg"
                />
              </div>
            </div>
            <div
              _ngcontent-ng-c2077610334=""
              className="casino-min-max text-dark"
            >
              <marquee
                _ngcontent-ng-c2077610334=""
                direction="left"
                scrollamount={3}
                behavior="scroll"
              >
                {" "}
                Select any 3 card and you will win If you do not get any card
                from the 3 cards you have selected.
              </marquee>
            </div>
          </div>
        </div>

        <app-results _ngcontent-ng-c2077610334="" _nghost-ng-c3559087628="">
          <div _ngcontent-ng-c3559087628="" className="recent-res teenpatti">
            <h5 _ngcontent-ng-c3559087628="" style={{ fontWeight: "bold" }}>
              Recent Result
            </h5>
            <ul _ngcontent-ng-c3559087628="" className="result">
              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>

              <li
                _ngcontent-ng-c3559087628=""
                data-bs-toggle="modal"
                data-bs-target="#CardJudgmentModal"
                className="casino-a"
              >
                <a _ngcontent-ng-c3559087628="" className="number text-dark">
                  {" "}
                  R{" "}
                </a>
              </li>
            </ul>
          </div>

          <div
            _ngcontent-ng-c3559087628=""
            id="CardRaceModal"
            tabIndex={-1}
            aria-labelledby="CardRaceModal"
            aria-hidden="true"
            className="modal fade"
          >
            <div _ngcontent-ng-c3559087628="" className="modal-dialog">
              <div _ngcontent-ng-c3559087628="" className="modal-content">
                <div
                  _ngcontent-ng-c3559087628=""
                  className="modal-header bet-slip-head"
                >
                  <h5
                    _ngcontent-ng-c3559087628=""
                    id="exampleModalLabel"
                    className="modal-title"
                  >
                    <b
                      _ngcontent-ng-c3559087628=""
                      style={{ textTransform: "capitalize" }}
                    ></b>
                  </h5>
                  <button
                    _ngcontent-ng-c3559087628=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    ×
                  </button>
                </div>
                <div
                  _ngcontent-ng-c3559087628=""
                  id="__BVID__33___BV_modal_body_"
                  className="modal-body"
                >
                  <div
                    _ngcontent-ng-c3559087628=""
                    style={{ marginBottom: 80 }}
                  >
                    <div
                      _ngcontent-ng-c3559087628=""
                      className="modal-title p-2"
                      style={{ float: "left" }}
                    >
                      <h6
                        _ngcontent-ng-c3559087628=""
                        className="text-right round-id"
                      >
                        <b _ngcontent-ng-c3559087628="">Round Id:</b>
                      </h6>
                    </div>
                    <div
                      _ngcontent-ng-c3559087628=""
                      className="col-12 col-md-12 col-xs-12 paati_boxs"
                    >
                      <ul _ngcontent-ng-c3559087628="" className="showall-card">
                        <img
                          _ngcontent-ng-c3559087628=""
                          src="../../../../assets/cards/CK_.png"
                          className="imgClassModal"
                        />
                        <span _ngcontent-ng-c3559087628="" className="ms-1">
                          -
                        </span>
                      </ul>
                      <ul _ngcontent-ng-c3559087628="" className="showall-card">
                        <img
                          _ngcontent-ng-c3559087628=""
                          src="../../../../assets/cards/DK_.png"
                          className="imgClassModal"
                        />
                        <span _ngcontent-ng-c3559087628="" className="ms-1">
                          -
                        </span>
                      </ul>
                      <ul _ngcontent-ng-c3559087628="" className="showall-card">
                        <img
                          _ngcontent-ng-c3559087628=""
                          src="../../../../assets/cards/HK_.png"
                          className="imgClassModal"
                        />
                        <span _ngcontent-ng-c3559087628="" className="ms-1">
                          -
                        </span>
                      </ul>
                      <ul _ngcontent-ng-c3559087628="" className="showall-card">
                        <img
                          _ngcontent-ng-c3559087628=""
                          src="../../../../assets/cards/SK_.png"
                          className="imgClassModal"
                        />
                        <span _ngcontent-ng-c3559087628="" className="ms-1">
                          -
                        </span>
                      </ul>
                    </div>
                    <div _ngcontent-ng-c3559087628="" className="clearfix" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            _ngcontent-ng-c3559087628=""
            id="CardJudgmentModal"
            tabIndex={-1}
            aria-labelledby="CardJudgmentModal"
            aria-hidden="true"
            className="modal fade"
          >
            <div _ngcontent-ng-c3559087628="" className="modal-dialog">
              <div _ngcontent-ng-c3559087628="" className="modal-content">
                <div
                  _ngcontent-ng-c3559087628=""
                  className="modal-header bet-slip-head"
                >
                  <h5
                    _ngcontent-ng-c3559087628=""
                    id="exampleModalLabel"
                    className="modal-title"
                  >
                    <b
                      _ngcontent-ng-c3559087628=""
                      style={{ textTransform: "capitalize" }}
                    ></b>
                  </h5>
                  <button
                    _ngcontent-ng-c3559087628=""
                    type="button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="close"
                  >
                    ×
                  </button>
                </div>
                <div
                  _ngcontent-ng-c3559087628=""
                  id="__BVID__33___BV_modal_body_"
                  className="modal-body"
                >
                  <div
                    _ngcontent-ng-c3559087628=""
                    style={{ marginBottom: 52 }}
                  >
                    <div
                      _ngcontent-ng-c3559087628=""
                      className="modal-title p-2"
                      style={{ float: "left" }}
                    >
                      <h6
                        _ngcontent-ng-c3559087628=""
                        className="text-right round-id"
                      >
                        <b _ngcontent-ng-c3559087628="">Round Id:</b>
                      </h6>
                    </div>
                  </div>
                  <div _ngcontent-ng-c3559087628="" className="col-12 mb-3">
                    <div
                      _ngcontent-ng-c3559087628=""
                      className="result-image text-center"
                    >
                      <img
                        _ngcontent-ng-c3559087628=""
                        className="p-0 me-3 border border-dark rounded"
                        style={{ width: 40 }}
                        src="assets/cards/null.png"
                      />
                      <img
                        _ngcontent-ng-c3559087628=""
                        className="p-0 me-3 border border-dark rounded"
                        style={{ width: 40 }}
                        src="assets/cards/null.png"
                      />
                      <img
                        _ngcontent-ng-c3559087628=""
                        className="p-0 me-3 border border-dark rounded"
                        style={{ width: 40 }}
                        src="assets/cards/null.png"
                      />
                    </div>
                  </div>
                  <div _ngcontent-ng-c3559087628="" className="clearfix" />
                </div>
              </div>
            </div>
          </div>
        </app-results>
      </div>
    </app-card-judgment>
  );
}
